export default {
      path: '/lvy-service-web',
      component: () => import('./LVYServiceWeb'),
      meta: {
        title: '青藤之恋',
        designWidth:750,
        expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (GMT+08:00)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
